import Api from '../../shared/Api';
import { IInvoiceProductTypeListItem } from './Types';

class InvoiceProductTypeApi {
    static list(): Promise<IInvoiceProductTypeListItem[]> {
        return new Api().get('/views/invoice-product-type');
    }

    static load(): Promise<any> {
        return new Api().get(`/views/invoice-product-type/new`);
    }

    static get(id: number): Promise<any> {
        return new Api().get(`/views/invoice-product-type/${id}`);
    }

    static create(name: string, site: number): Promise<any> {
        return new Api().post(`/views/invoice-product-type/`, { name, site });
    }

    static edit(id: number, name: string, country: number, site: number, isSystemDefault: boolean): Promise<any> {
        return new Api().post(`/views/invoice-product-type/${id}`, {
            id,
            name,
            country,
            site,
            isSystemDefault
        });
    }

    static delete(id: number): Promise<any> {
        return new Api().delete(`/views/invoice-product-type/${id}`);
    }
}

export default InvoiceProductTypeApi;
